import {
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  YoutubeLogo,
  XLogo,
} from "@phosphor-icons/react";

export const socialMediaLinks = [
  {
    name: "facebook",
    url: "https://www.facebook.com/profile.php?id=61582416441371",
    icon: FacebookLogo,
  },
  {
    name: "instagram",
    url: "https://www.instagram.com/iasco.solutions1?igsh=d2Fsbjh0YTVjanVz",
    icon: InstagramLogo,
  },
  {
    name: "linkedin",
    url: "https://www.linkedin.com/company/105761361",
    icon: LinkedinLogo,
  },
  {
    name: "youtube",
    url: "https://www.youtube.com/@iasco-d7c?si=FfDcx1u-WaBG9gXM",
    icon: YoutubeLogo,
  },
  {
    name: "x",
    url: "https://x.com/internatio80631",
    icon: XLogo,
  },
];
